import {CONFIG} from '../../appConfig';
const ENROLLMENT = 'enrollment/';

export default {
  /**
  * @desc Get user profile information for enrollment if it's avaiable
  * @param {Object} data {payload, params}
  * @returns {Object}
  * @memberof services.gma.enrollment
  * @example
  * const payload = {"driver_license_number":"AMN5456478NB","country_subdivision":"MO","country":"US","last_name":"Brazil","activate_flow":false, loyalty_number:"1234567890"}
  * services.gma.enrollment.profileSearch({payload});
  * update session with the response
  */
  profileSearch(data = {}) {
    const {payload = {}, params = {}} = data;
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${ENROLLMENT}profileSearch`,
      data: payload,
      params
    };
  },

  /**
  * @desc submits personal infomation for enrollment
  * @param {Object} data {payload, params}
  * @returns {Object}
  * @memberof services.gma.enrollment
  * @example
  * const payload = {
  *   "first_name":"teste",
  *   "last_name":"testing",
  *   "address":{
  *      "street_addresses":[
  *         "126 Irving St"
  *      ],
  *      "city":"Hartford",
  *      "country_subdivision_code":"CT",
  *      "country_code":"US",
  *      "postal":"06101",
  *      "address_type":"HOME"
  *   },
  *   "email":"test@test.com",
  *   "phones":[
  *      {
  *         "phone_type":"HOME",
  *         "phone_number":"2034331158",
  *         "extension":"",
  *         "priority":1
  *      }
  *   ],
  *   "drivers_license":{
  *      "license_number":"2342342342342",
  *      "license_issue_date":"",
  *      "license_expiration_date":"2024-12-01",
  *      "country_subdivision_code":"CT",
  *      "country_code":"US"
  *   },
  *   "preferred_language":"en",
  *   "request_origin_channel":"ENROLLMENT",
  *   "preference":{
  *      "return_domain_preferences":true
  *   },
  *   "contact":{
  *      "email":"teste@teste.com",
  *      "phones":[
  *         {
  *            "phone_type":"HOME",
  *            "phone_number":"2034331158",
  *            "extension":"",
  *            "priority":1
  *         }
  *       ]
  *   },
  *   "date_of_birth":"1998-11-11",
  *   };
  * services.gma.enrollment.submitPersonalInformation({payload});
  * update session with the response
  */
  submitPersonalInformation(data = {}) {
    const {payload = {}, params = {}} = data;
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${ENROLLMENT}submitPersonalInformation`,
      data: payload,
      params
    };
  },

  /**
  * @desc Create loyalty account to finish users enrollment
  * @param {Object} data {payload, params}
  * @returns {Object}
  * @memberof services.gma.enrollment
  * @example
  {
    "user_name": "testuser",
    "password": "National@1",
    "payment": {
        "payment_method": {
            "preferred": true,
            "sequence": 0,
            "payment_type": "CREDIT_CARD",
            "credit_card_expired": false,
            "masked_number": "7374",
            "credit_card_near_expiration": false,
            "payment_session_id": "DVFJ1YZT7JTC5",
            "expiration_date": "2029-11",
            "expiration_date_display": "11/2029"
        }
    },
    "preference": {
        "email_preference": {
            "special_offers": true,
            "rental_receipts": true
        },
        "rental_preferences": {
            "equipment_preferences": [
                {
                    "type_code": "GPS",
                    "accept": false,
                    "quantity": 1,
                    "priority": 0
                }
            ],
            "fuel_preferences": {
                "pre_paid_fuel_acceptance": false
            },
            "vehicle_preferences": [],
            "protection_region_preferences": [
                {
                    "region_code": "USA",
                    "regional_protections": [
                        {
                            "type_code": "LDW1",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        },
                        {
                            "type_code": "PAI/PEC",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        },
                        {
                            "type_code": "SLI",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        },
                        {
                            "type_code": "RSP",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        }
                    ]
                },
                {
                    "region_code": "CAN",
                    "regional_protections": [
                        {
                            "type_code": "LDW1",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        },
                        {
                            "type_code": "PAI/PEC",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        },
                        {
                            "type_code": "RSP",
                            "accept": true,
                            "version": 0,
                            "signed": true
                        }
                    ]
                }
            ]
        },
        "reward_preferences": {
            "partner_rewards_programs": [],
            "reward_type": "CREDITS"
        }
    },
    "terms_and_conditions": {
        "accept_decline": true,
        "accept_decline_version": "9.0"
    }
}
  * services.gma.enrollment.createLoyaltyAccount({payload});
  * update session with the response
  */
  createLoyaltyAccount(data = {}) {
    const {payload = {}, params = {}} = data;
    return {
      method: 'POST',
      origin: CONFIG.GMA_ORIGIN_URL,
      endpoint: `${ENROLLMENT}createLoyaltyAccount`,
      data: payload,
      params
    };
  }
};
